import React, { useState, useRef, useEffect } from "react";
import { Eye, EyeOff } from "lucide-react";
import { decrypt, encrypt } from "../utils/cryptoUtils";
import { makeAuthenticatedRequest } from "../utils/api";
import { useDispatch } from "react-redux";
import { AxiosError } from "../components/sessionexpiry";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";


const DeveloperTools = ({ isSidebarCollapsed, isMobile }) => {
  const [payoutcallback, setpayoutcallback] = useState("");
  const [errors, setErrors] = useState({ payoutcallback: "" });
  const [showPassword, setShowPassword] = useState(false);
  const inputRef = useRef(null);

  const users = JSON.parse(sessionStorage.getItem("users"));
  const user_id = users?.userdatils?.kycs_step ? users.userdatils.user_id : "0";

  const payouthandlesubmit = (e) => {
    e.preventDefault();

    const newErrors = { payoutcallback: "" };
    let isValid = true;

    // Beneficiary Name validation
    if (!payoutcallback.trim()) {
      newErrors.payoutcallback = "Payout callback URL is required.";
      isValid = false;
    } else {
      // Simple URL pattern check
      const urlPattern = /^(https?:\/\/)?([\w\-]+\.)+[\w\-]{2,}(\/\S*)?$/;
      if (!urlPattern.test(payoutcallback.trim())) {
        newErrors.payoutcallback = "Enter a valid URL.";
        isValid = false;
      }
    }
    setErrors(newErrors);
    // Only proceed with the update if there are no errors
  if (isValid) {
    handleUpdate();
  }
  };

  const handleUpdate = async () => {
    try {
      const updateJson = JSON.stringify({
        Dname: "flipopay_payouts",
        Tname: "merchants",
        Set: {
          webhook_url: payoutcallback,
          webhook_status: "1"
        },
        Where: {
          mid: user_id,
        },
        Limit: "1"
      });
  
      const encrypted = encrypt(updateJson);
  
      const response = await makeAuthenticatedRequest(
        "POST",
        "/update",
        { encrypted: encrypted },
        navigate
      );
  
      const decryptdata = decrypt(response);
  
      const jsonArray = JSON.parse(decryptdata.replace(/\\"/g, '"'));
  
      if (jsonArray["Status count"] === "200") {
        toast.success("CallBack updated successfully");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        toast.error("Update failed");
      }
    } catch (err) {
      setError(err.message);
      AxiosError(navigate, err);
    }
  };  

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [responseData, setResponseData] = useState(null);



  const [profileData, setProfileData] = useState({
    mid: "",
    webhook_url: "",
    client_secret: ""
  });

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        const requestData = JSON.stringify({
          Dname: "flipopay_payouts",
          Tname: "merchants m",
          Cname: [
            "m.mid",
            "webhook_url",
            "X_Secret_Key"
          ],
          Where: [
            { 
              column: "m.mid",
              operator: "=",
              value: user_id 
            },
          ],
          Limit: "10",
          Offset: "0",
        });

        const encrypted = encrypt(requestData);
        const data = await makeAuthenticatedRequest(
          "POST",
          "/fetch",
          { encrypted },
          navigate
        );
        
        const decryptdata = decrypt(data);
        const fixedString = decryptdata.replace(/\\"/g, '"');
        const jsonArray = JSON.parse(fixedString);

        if (jsonArray.length > 0) {
          setProfileData({
            mid: jsonArray[1]["m.mid"] || "",
            webhook_url: jsonArray[1].webhook_url || "",
            client_secret: jsonArray[1]["X_Secret_Key"] || ""
          });
        }

        setResponseData(jsonArray);
      } catch (err) {
        setError(err.message);
        AxiosError(navigate, err);
      }
    };

    fetchProfileData();
  }, [dispatch, user_id, navigate]);

  

  return (
    <div className={`bg-[#F4F5FA] min-h-screen`}>
      {/* Header & Sidebar */}
      {/* <Header
        toggleSidebar={toggleSidebar}
        isSidebarCollapsed={isSidebarCollapsed}
      />
      <Sidebar
        isSidebarCollapsed={isSidebarCollapsed}
        toggleSidebar={toggleSidebar}
      /> */}

      <main className="main-content">
        <div
          className={`mx-auto p-4 md:p-4 transition-all duration-300 ${
            isSidebarCollapsed && !isMobile
              ? "lg:ml-20"
              : !isSidebarCollapsed && !isMobile
              ? "lg:ml-[270px]"
              : "ml-0"
          }`}
        >
          {/* Main Content */}
          <div className="mb-6 flex flex-wrap items-center justify-between ml-4">
            <div>
              <h2 className="text-xl font-semibold text-gray-800">Developer Tools</h2>
              {/* <p className="text-sm text-gray-600 mt-1">Manage your account payouts and transactions</p> */}
            </div>
            <nav>
              <ol className="flex items-center space-x-2 text-sm">
                <li>
                  <Link
                    className="flex items-center text-gray-500 hover:text-[#299F1F] transition-colors"
                    to="/dashboard"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4 mr-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                      />
                    </svg>
                    Home
                  </Link>
                </li>
                <li className="text-gray-400">/</li>
                <li className="font-medium text-gray-800">Developer Tools</li>
              </ol>
            </nav>
          </div>

          {/* Main content goes here */}

          <div class="grid lg:grid-cols-2 gap-6 lg:ml-4">
            {/* <!-- First Row --> */}
            <div class="relative rounded-2xl border border-gray-200 bg-white p-2 lg:p-6">
              <label class="rounded-2xl left-6 px-2 text-xl font-medium text-[#299F1F]">
                API Credentials ( X-Secret-Key )
              </label>
              <div class="space-y-4 mt-4">
                {/* <div className="flex items-center">
                  <input
                    ref={inputRef}
                    type="text"
                    placeholder="Client ID"
                    value={profileData.client_id}
                    className="w-full h-[50px] p-2 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm focus:ring-[#635BFF]"
                  />
                  <div
                    className="flex lg:ml-4 gap-1 cursor-pointer"
                    onClick={() => {
                      if (inputRef.current) {
                        inputRef.current.select();
                        document.execCommand("copy"); // fallback
                        navigator.clipboard?.writeText(inputRef.current.value); // modern
                      }
                    }}
                  >
                    <span className="material-symbols-outlined text-gray-600">
                      content_copy
                    </span>
                    <button type="button" className="text-gray-600">
                      Copy
                    </button>
                  </div>
                </div> */}
                {/* <div class="flex items-center">
                    <input id="collectionsSecret" type="password" placeholder="Collections Client Secret" class="flex-1 h-[60px] rounded-lg border border-gray-300 bg-transparent py-2.5 pl-4 pr-11 text-sm text-gray-800 placeholder:text-gray-400 focus:border-brand-300 focus:outline-none focus:ring focus:ring-brand-500/10 "/>
                    <div  class="flex lg:ml-4 gap-1">
                    <svg   xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#465FFF"><path d="M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Zm0-300Zm0 220q113 0 207.5-59.5T832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280Z"/></svg>
                    <button  id="toggleCollections" class="text-[#465FFF]">Show</button>
                    </div>
                </div> */}
                <div class="flex items-center">
                  <div className="relative flex items-center w-full">
                    <input
                      id="payoutsSecret"
                      type={showPassword ? "text" : "password"}
                      placeholder="Payouts Client Secret"
                      value={profileData.client_secret}
                      // className="flex-1 h-[50px] rounded-lg border border-gray-300 bg-transparent py-2.5 pl-4 pr-11 text-sm text-gray-800 placeholder:text-gray-400 focus:border-blue-500 focus:outline-none focus:ring focus:ring-blue-500/10"
                      className="w-full h-[50px] p-2 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm focus:ring-[#299F1F] pr-20"
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute right-3 flex items-center space-x-1 text-gray-600 text-sm"
                    >
                      {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                      <span>{showPassword ? "Hide" : "Show"}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {/* <button id="togglePayouts" class="text-[#465FFF]">
                      Show
                    </button> */}
            {/* <!-- Collection WEbhook --> */}
            {/* <div class="relative rounded-2xl border border-gray-200 bg-white p-2 lg:p-6">
            <label class="absolute -top-3 left-4 px-2 text-lg font-medium text-[#465FFF]">Collections Webhook</label>
            <div class="space-y-4 mt-4">
                <!-- Callback URL Input -->
                <input id="callbackURL" type="text" placeholder="Callback URL" class="w-full h-[60px] rounded-lg border border-gray-300 bg-transparent py-2.5 pl-4 pr-11 text-sm text-gray-800 placeholder:text-gray-400 focus:border-blue-500 focus:outline-none focus:ring focus:ring-blue-500/10 "/>
                <p id="callbackURLError" class="text-red-500 text-sm hidden">Invalid URL! Enter a valid Callback URL.</p>
        
                <!-- Checksum Secret Input -->
                <div class="flex items-center gap-2">
                    <input id="checksumSecret" type="password" placeholder="Checksum Secret" class="flex-1 h-[60px] rounded-lg border border-gray-300 bg-transparent py-2.5 pl-4 pr-11 text-sm text-gray-800 placeholder:text-gray-400 focus:border-blue-500 focus:outline-none focus:ring focus:ring-blue-500/10 "/>
                    <svg id="eyeIcon1" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#465FFF">
                        <path d="M480-320q75 0 127.5-52.5T660-500q0-75-52.5-12.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Zm0-300Zm0 220q113 0 207.5-59.5T832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280Z"/>
                    </svg>
                    <button id="togglePassword" class="text-[#465FFF]">Show</button>
                </div>
                <p id="checksumSecretError" class="text-red-500 text-sm hidden">Checksum Secret cannot be empty.</p>
        
                <!-- Submit Button -->
                <button id="submitBtn" class="w-full bg-[#465FFF] text-white rounded-lg py-2.5">Submit</button>
            </div>
          </div> */}

            {/* <!-- Second Row --> */}
            <div class="relative rounded-2xl border border-gray-200 bg-white p-2 lg:p-6">
              <label class="px-2 text-xl font-medium text-[#299F1F]">
                Documentation
              </label>
              <div class="space-y-4 mt-4">
                <a
                //https://jantapays-files.s3.us-east-1.amazonaws.com/Payout_API_Documentation_v1.0.pdf
                  href="https://jantapays-files.s3.us-east-1.amazonaws.com/Payout_API_Documentation_v1.0.pdf" // Replace with your file path 
                  download
                  type="pdf"
                  target="blank"
                  class="flex items-center cursor-pointer"
                >
                  <p class="flex-1">
                    Download Payout API Documentation v1.0
                  </p>
                  <span class="material-symbols-outlined text-[#299F1F]">
                    download
                  </span>
                </a>
              </div>
            </div>

            {/* <!-- Payout Webhook --> */}
            <form onSubmit={payouthandlesubmit}>
              <div class="relative rounded-2xl border border-gray-200 bg-white p-2 lg:p-6 mt-4">
                <label class="left-4 px-2 text-xl font-medium text-[#299F1F]">
                  Payout Webhook
                </label>
                <div class="space-y-4 mt-4">
                  {/* <!-- Callback URL Input --> */}
                  <input
                    id="callbackURL1"
                    type="text"
                    placeholder={profileData.webhook_url}
                    maxLength={100}
                    value={payoutcallback}
                    onChange={(e) => setpayoutcallback(e.target.value)}
                    //  class="w-full h-[60px] rounded-lg border border-gray-300 bg-transparent py-2.5 pl-4 pr-11 text-sm text-gray-800 placeholder:text-gray-400 focus:border-blue-500 focus:outline-none focus:ring focus:ring-blue-500/10 "
                    className={`w-full h-[50px] p-2 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm ${
                      errors?.payoutcallback
                        ? "border-[#DC2626] focus:ring-[#DC2626]"
                        : "focus:ring-[#299F1F]"
                    }`}
                  />
                  {errors.payoutcallback && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.payoutcallback} 
                    </p>
                  )}

                  {/* <!-- Checksum Secret Input --> */}
                  {/* <div class="flex items-center gap-2">
                    <input id="checksumSecret1" type="password" placeholder="Checksum Secret" class="flex-1 h-[60px] rounded-lg border border-gray-300 bg-transparent py-2.5 pl-4 pr-11 text-sm text-gray-800 placeholder:text-gray-400 focus:border-blue-500 focus:outline-none focus:ring focus:ring-blue-500/10 "/>
                    <svg id="eyeIcon1" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#465FFF">
                        <path d="M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Zm0-300Zm0 220q113 0 207.5-59.5T832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280Z"/>
                    </svg>
                    <button id="togglePassword1" class="text-[#465FFF]">Show</button>
                </div>
                <p id="checksumSecretError1" class="text-red-500 text-sm hidden">Checksum Secret cannot be empty.</p> */}

                  {/* <!-- Submit Button --> */}
                  <button class="w-full bg-[#299F1F] text-white rounded-lg py-2.5">
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </main>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default DeveloperTools;
